<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="settingForm">
        <div slot="body">
          <bita-formgroup
            title="تنظیمات سالن"
            class="row justify-content-center"
            style="margin-left: 1px"
          >
            <bita-select
              id="check_tonnage_limit"
              name="check_tonnage_limit"
              rules="required"
              label="آیا محدودیت تناژ چک شود؟"
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              data-text-field="title"
              data-value-field="value"
              :data-source="[
                { title: 'بله', value: 1 },
                { title: 'خیر', value: 0 }
              ]"
              v-model="config.check_tonnage"
            />

            <bita-select
              id="check_driver_location_on_reserve"
              name="check_driver_location_on_reserve"
              rules="required"
              label="موقعیت جغرافیایی راننده موقع رزرو چک شود؟"
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              data-text-field="title"
              data-value-field="value"
              :data-source="[
                { title: 'بله', value: 1 },
                { title: 'خیر', value: 0 }
              ]"
              v-model="config.force_in_location_for_reserve"
            />

            <bita-select
              id="check_driver_location_on_delivery"
              name="check_driver_location_on_delivery"
              rules="required"
              label="موقعیت جغرافیایی راننده موقع تحویل چک شود؟"
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              data-text-field="title"
              data-value-field="value"
              :data-source="[
                { title: 'بله', value: 1 },
                { title: 'خیر', value: 0 }
              ]"
              v-model="config.force_in_location_for_deliver"
            />

            <bita-select
              id="is_good"
              name="is_good"
              rules="required"
              label="آیا بار خوب است یا بد؟"
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              data-text-field="title"
              data-value-field="value"
              :data-source="[
                { title: 'بله', value: 1 },
                { title: 'خیر', value: 0 }
              ]"
              v-model="config.is_good"
            />

            <bita-select
              id="is_exclusive"
              name="is_exclusive"
              rules="required"
              label="آیا بار اختصاصی می‌باشد؟"
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              data-text-field="title"
              data-value-field="value"
              :data-source="[
                { title: 'بله', value: 1 },
                { title: 'خیر', value: 0 }
              ]"
              v-model="config.is_exclusive"
            />

            <bita-select
              id="is_queue_correct"
              name="is_queue_correct"
              rules="required"
              label="آیا بار نوبت به‌جا است یا خیر؟"
              validation-container-class="col-lg-4 col-md-6 col-sm-6"
              input-class="form-control"
              data-text-field="title"
              data-value-field="value"
              :data-source="[
                { title: 'بله', value: 1 },
                { title: 'خیر', value: 0 }
              ]"
              v-model="config.change_ticket"
            />

            <bita-bootbutton
              type="primary"
              title="ذخیره تنظیمات"
              btn-width="300px"
              @click.native="handleSubmit"
            />
          </bita-formgroup>
        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>

<script>

export default {
  props: {
    modalId: {},
    title: {},
    propsConfig: {
      type: Object,
      default: () => ({}),
    },
     propsSalonId: { 
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      config: {}, 
    };
  },
  watch: {
    propsConfig(_data) {
      this.config = _data || {};
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.settingForm.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", 
              this.config,
          
          );
        }
      });
    },
    onCloseModal() {
      this.$refs.settingForm.reset();

    },
  },
};
</script>
